import useFetch from '@hooks/useFetch';
import { useMemo } from 'react';

interface ClassTypeOption {
  content: string;
  id: string | number | null;
}

interface UseClassTypeFilterOptionsResponse {
  options: ClassTypeOption[];
  hasOptions: boolean;
  isLoading: boolean;
  isError: boolean;
}

const useClassTypeFilterOptions = (
  goalUID?: string
): UseClassTypeFilterOptionsResponse => {
  const { data, isLoading, isError } = useFetch(
    goalUID ? `v1/batch/class_type_filter_options/?goal_uid=${goalUID}` : null
  );

  const typedData = data as ClassTypeOption[] | undefined;

  const options = useMemo<ClassTypeOption[]>(() => {
    if (!Array.isArray(typedData) || typedData.length === 0) {
      return [];
    }

    return typedData;
  }, [typedData]);

  const hasOptions = options.length > 0;

  return {
    options,
    hasOptions,
    isLoading,
    isError
  };
};

export default useClassTypeFilterOptions;
